import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { parseISO, format, addDays } from "date-fns";
import { Link, useHistory } from "react-router-dom";
import flag from "../../../assets/images/v3/icons/color_bar.svg";
import Header from "../../components/Renewal/Header";
import SelectDate from "../../components/FormComponents/SelectDate/SelectDate";
import moment from "moment";

import Datepicker from "../../components/FormComponents/Datepicker/Datepicker";

var formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});

const EditRenewal = (props) => {
	const [drivers, setDrivers] = useState([]);
	const [cars, setCars] = useState([]);
	const [liabilityCoverage, setLiabilityCoverage] = useState(1);
	const [policyStart, setPolicyStart] = useState(null);

	let history = useHistory();
	const dispatch = useDispatch();

	const renewalData = useSelector((state) => state.RenewalData);
	const renewalDataDefault = useSelector((state) => state.RenewalDataDefault);
	const renewalId = useSelector((state) => state.RenewalId);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (renewalData) {
			let start = new Date(renewalData.policy_start);
			start.setDate(start.getDate() + 1);
			setPolicyStart(start);
			setDrivers(renewalData.drivers);
			setCars(renewalData.cars);
			setLiabilityCoverage(renewalData.liability_coverage);
		}
	}, [renewalData]);

	const confirmChanges = () => {
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(renewalData),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((res) => {
				dispatch({
					type: "SET_INITIAL_QUOTE_DATA",
					payload: res.quote,
				});
				history.goBack();
			});
	};

	const cancelChanges = () => {
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(renewalDataDefault),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((res) => {
				dispatch({
					type: "SET_INITIAL_QUOTE_DATA",
					payload: res.quote,
				});
				history.goBack();
			});
	};

	return (
		<div className="editrenewal general d-flex justify-content-center	">
			<div className="otcontainer1">
				<div className="col">
					<div className="row justify-content-md-center">
						<h1 className="col-12 otmt-4 otmb-4" style={{ color: "#00788A" }}>
							Change My Coverage
						</h1>
						<hr className="softline l1 mt-2" />

						<div className="col-12 col-md-11 d-flex justify-content-between">
							<h3 className="">Term of Coverage</h3>
						</div>

						<div className="col-11 ml-md-0 otmb-1">
							<div className="col-md-6 pl-0">
								<Datepicker
									label="POLICY START DATE"
									classLabel="mt-2 h5"
									classInput="form-control mb-md-3 text-left"
									val={policyStart}
									setVal={setPolicyStart}
									minDate={policyStart}
									maxDate={addDays(policyStart, 31)}
									name="startPolicy"
								/>
							</div>
						</div>
						<hr className="softline l1 mt-2" />
						<div className="col-12 col-md-11 d-flex justify-content-between">
							<h3 className="">My Vehicles</h3>

							<Link
								to={`/v3/renewals/${renewalId}/react/vehicles`}
								className="col-5 d-flex justify-content-end pr-0"
								style={{ maxWidth: "160px" }}
							>
								<button type="button" className="btn btn1 col-7 mt-2">
									EDIT
								</button>
							</Link>
						</div>

						{cars.map((car, i) => (
							<React.Fragment key={i}>
								<div className="col-11 ml-md-0">
									<h3 className="" style={{ color: "#00788A" }}>
										{car.year} {car.make} {car.car_model}
									</h3>
									<div className="align-items-baseline d-flex">
										<p className="font-weight-bold text-uppercase mb-0">
											COVERAGE VALUE:{" "}
										</p>
										<p className="ml-1 mb-0">{formatter.format(car.value)}</p>
									</div>
									<div className="align-items-baseline d-flex">
										<p className="font-weight-bold text-uppercase">
											DEDUCTIBLE:{" "}
										</p>
										<p className="ml-1">
											{formatter.format(
												(car.value * car.deductible_percentage) / 100
											)}{" "}
											({Math.round(car.deductible_percentage)}%)
										</p>
									</div>
								</div>
							</React.Fragment>
						))}

						<hr className="softline l1 mt-3" />
						<div className="col-12 col-md-11 d-flex justify-content-between">
							<h3 className="">Drivers</h3>
							<Link
								to={`/v3/renewals/${renewalId}/react/drivers`}
								className="col-5 d-flex justify-content-end pr-0"
								style={{ maxWidth: "160px" }}
							>
								<button type="button" className="btn btn1 col-7 mt-2">
									EDIT
								</button>
							</Link>
						</div>
						{drivers.map((driver, i) => {
							return (
								<div className="col-11 mb-4 ml-md-0" key={i}>
									<div className="mb-4 ml-md-1">
										<p className="d-flex mb-0 t6">
											{driver.first_name} {driver.last_name}
											<p className="ml-2 text-uppercase">{driver.relation}</p>
										</p>

										<p className="mb-1">
											{driver.date_of_birth &&
												format(parseISO(driver.date_of_birth), "PPP")}
										</p>
										<p className="mb-1">{driver.email}</p>
										<p className="mb-1">{driver.phoneNumber}</p>
										<p className="mb-1">
											{driver.street} {driver.city}, {driver.state} {driver.zip}
										</p>
										{/* <p className="col-10 mb-1 pr-1">{driver.city},</p>
										<p className="mb-1"> {driver.state}</p>
										<p className="mb-1 ml-2"> {driver.zip}</p> */}
									</div>
								</div>
							);
						})}

						<hr className="softline l1 mt-3" />
						{_.get(renewalData, `liability_coverage`, false) ? (
							<div className="col-12 col-md-11 d-flex justify-content-between">
								<h3 className="">Liability Protection</h3>
								<Link
									to={`/v3/renewals/${renewalId}/react/liability`}
									className="col-5 d-flex justify-content-end pr-0"
									style={{ maxWidth: "160px" }}
								>
									<button type="button" className="btn btn1 col-7 mt-2 ">
										EDIT
									</button>
								</Link>
							</div>
						) : (
							<>
								<div className="col-12 col-md-11 d-flex justify-content-between">
									<h3 className="" style={{ color: "#00788A" }}>
										Get liability protection
									</h3>
									<Link
										to={`/v3/renewals/${renewalId}/react/liability`}
										className="col-5 d-flex justify-content-end pr-0"
										style={{ maxWidth: "160px" }}
									>
										<button type="button" className="btn btn1 col-7 mt-2 ">
											ADD
										</button>
									</Link>
								</div>
								<div className="col-11">
									<p>
										Liability provides financial protection if you harm someone
										else or their property;
										<br />
										including track property.
									</p>
								</div>
							</>
						)}

						{_.get(renewalData, `liability_coverage`) ? (
							<>
								<div className="align-items-baseline col-11 d-flex ml-md-0">
									<p className="mb-0 font-weight-bold text-uppercase">
										COVERAGE VALUE:{" "}
									</p>
									<p className="ml-2 mb-0">
										{formatter.format(
											String(_.get(renewalData, `liability_coverage`, 0))
										)}
									</p>
								</div>
								<div className="align-items-baseline d-flex col-11 ml-md-0">
									<p className="font-weight-bold text-uppercase">DEDUCTIBLE:</p>
									<p className="ml-2">$2,500.00</p>
								</div>
							</>
						) : null}

						<hr className="softline l1 mt-3" />
						{_.get(renewalData, `covers_misc_damage`, false) ? (
							<div className="col-12 col-md-11 d-flex justify-content-between">
								<h3 className="">Property Protection</h3>
								<Link
									to={`/v3/renewals/${renewalId}/react/property`}
									className="col-5 d-flex justify-content-end pr-0"
									style={{ maxWidth: "160px" }}
								>
									<button type="button" className="btn btn1 col-7 mt-2">
										EDIT
									</button>
								</Link>
							</div>
						) : (
							<>
								<div className="col-12 col-md-11 d-flex justify-content-between">
									<h3 className="" style={{ color: "#00788A" }}>
										Cover your property at the track
									</h3>
									<Link
										to={`/v3/renewals/${renewalId}/react/property`}
										className="col-5 d-flex justify-content-end pr-0"
										style={{ maxWidth: "160px" }}
									>
										<button type="button" className="btn btn1 col-7 mt-2">
											ADD
										</button>
									</Link>
								</div>
								<div className="col-11">
									<p>
										Adds $25,000 of Miscellaneous Property Coverage for
										additional
										<br />
										$41.67 + taxes per month
									</p>
								</div>
							</>
						)}
						{_.get(renewalData, `covers_misc_damage`) ? (
							<>
								<div className="align-items-baseline d-flex col-11 ml-md-0">
									<p className="mb-0 font-weight-bold text-uppercase">
										COVERAGE VALUE:
									</p>
									<p className="ml-2 mb-0">$1,000,000.00</p>
								</div>
								<div className="align-items-baseline d-flex col-11 ml-md-0">
									<p className="font-weight-bold text-uppercase">DEDUCTIBLE:</p>
									<p className="ml-2">$2,500.00</p>
								</div>
							</>
						) : null}
						<hr className="softline l1 mt-3" />
						<div className="justify-content-end mx-auto my-5 row">
							<div className="col-12 col-lg-2 mb-3" style={{ display: "flex" }}>
								<button
									type="button"
									className=" btn btn1 btn-lg mx-auto"
									onClick={() => cancelChanges()}
								>
									CANCEL
								</button>
							</div>
							<div className="col-12 col-lg-4 mb-3" style={{ display: "flex" }}>
								<button
									type="submit"
									className="col-md-12 btn btn2 btn-lg mx-auto"
									onClick={() => confirmChanges()}
									style={{ minWidth: "160px" }}
								>
									CONFIRM CHANGES
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default EditRenewal;
